/**
 * Constants for the Drawdown Tool
 */

// URL parameter keys
export const DT_URL_PARAMS = {
  LAT: "dt_lat",
  LON: "dt_lon",
};

// Custom event names
export const DRAWDOWN_TOOL_EVENTS = {
  URL_PARAMS_CHANGED: "drawdownToolUrlParamsChanged",
};

// API endpoint builders
export const DRAWDOWN_API_ENDPOINTS = {
  AQUIFERS: "/api/public-map/drawdown/aquifers",
  UNITS: "/api/public-map/drawdown/units",
  PROPOSED_WELL: "/api/public-map/drawdown/proposed-well",
  RUNS: "/api/public-map/drawdown/runs",
  RUN_DETAILS: (runNdx) => `/api/public-map/drawdown/runs/${runNdx}/details`,
  RUN_RESULTS: (runNdx) => `/api/public-map/drawdown/runs/${runNdx}/results`,
  RUN_REPORT: (runNdx) => `/api/public-map/drawdown/runs/${runNdx}/report`,
  DELETE_RUN: (runNdx) => `/api/public-map/drawdown/runs/${runNdx}`,
};

// View states for DrawdownToolControl
export const VIEW_STATES = {
  MAIN: "main",
  NEW_RUN: "newRun",
  PREVIOUS_RUNS: "previousRuns",
};

// Cache times for React Query
export const CACHE_TIMES = {
  AQUIFERS_UNITS: 5 * 60 * 1000, // 5 minutes
  RUNS_LIST: 30 * 1000, // 30 seconds
  RUN_DETAILS: 5 * 60 * 1000, // 5 minutes
};

// Data source identifiers
export const DATA_SOURCES = {
  GAM_DATASET: "GAM Dataset",
};

// Units constants
export const UNITS = {
  FEET: "Feet",
  FEET_LOWERCASE: "feet",
};

// Wizard steps
export const WIZARD_STEPS = [
  "Location",
  "Well Details",
  "Custom Inputs",
  "Notes",
  "Review & Run",
];

// Date formatting options
export const DATE_FORMATS = {
  FULL: {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  },
  SHORT: {
    year: "numeric",
    month: "short",
    day: "numeric",
  },
  TIME: {
    hour: "2-digit",
    minute: "2-digit",
  },
};

// Error messages
export const ERROR_MESSAGES = {
  SUBMIT_FAILED: "Failed to submit analysis. Please try again.",
  DOWNLOAD_FAILED: "Failed to download report. Please try again.",
  DELETE_FAILED: "Failed to delete run. Please try again.",
  LOAD_FAILED: "Failed to load data. Please try again.",
  NO_RUN_RESULTS: "Failed to get run results. Please try again.",
};

// Default form state
export const DEFAULT_FORM_STATE = {
  latitude_dd: "",
  longitude_dd: "",
  proposed_well_name: "",
  aquifer_ndx: "",
  distance_radius: "",
  distance_units: "",
  proposed_annual_af: "",
  proposed_rate_gpm: "",
  use_custom_t: false,
  custom_transmissivity: "",
  use_custom_s: false,
  custom_storativity: "",
  run_notes: "",
};
